<!--
 * @Author: your name
 * @Date: 2021-03-04 16:20:58
 * @LastEditTime: 2026-05-08 17:24:08
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\views\Home.vue
-->
<template>
  <div class="home-container flex-d-b-c" v-if="$cookies.get('role_id') !== '3'">
    <div class="navigation flex-a-c">
      <template v-for="(s, index) in ShortcutList">
        <template>
          <Shortcut :title="s.title" :describe="s.describe" :key="index"></Shortcut>
          <img v-if="index < ShortcutList.length - 1" class="arrow-right" src="@/assets/images/home/arrow-right.png" alt
            :key="index + 'img'" />
        </template>
      </template>
    </div>
    <div class="flex-b-c h-chart">
      <div class="h-msg">
        <div class="title-font flex-b-c">{{ $t('chi1') }}</div>
        <div class="msg-body">
          <!-- <kares-msg title="系统消息" :describe="karesDescribe"></kares-msg> -->
          <kares-msg :title="$t('chi2')" :describe="systemMemory + dataMemory"
            v-if="$cookies.get('isadmin') != 0"></kares-msg>
          <kares-msg :title="$t('chi2')" describe="" v-if="$cookies.get('isadmin') != 0">
            {{ $t('chi3') }} -<el-button size="mini" @click="getAllMac">getAllMac</el-button>
          </kares-msg>
          <kares-msg :title="$t('chi1')" describe="" :time="value.data.event_time"
            v-for="(value, index) in commonInfoList" :key="index">
            <span>{{ `${value.device_name}-${value.data.event_name}-` }}</span>
            <span style="color: #41f167;" v-if="value.data.event_value == 1">{{ $t('ctcip17') }}</span>
            <span style="color: #f00;" v-else>{{ $t('ctcip18') }}</span>
          </kares-msg>
        </div>
      </div>
      <div class="flex-d h-device" v-loading="dmLoading" :element-loading-text="$t('chi4')">
        <div style="width: 100%" class="flex-a-c">
          <div id="chartOnline"></div>
          <div id="chartResolution"></div>
        </div>
        <div style="width: 100%" class="flex-a-c">
          <div id="chartMaterialNum"></div>
          <div id="chartMaterialType"></div>
        </div>
      </div>
      <div class="h-program flex-d" v-loading="pmLoading" :element-loading-text="$t('chi4')">
        <div class="h-p-switch flex-b-c">
          <div class="title-font flex-b-c" v-loading="downloadLoading" :element-loading-text="$t('chi51')">
            {{ $t('chi5') }}
            <el-tooltip class="item" effect="dark" :content="$t('chi6')" placement="top">
              <img src="@/assets/images/home/export.png" @click="exportStatistics" width="20" height="20"
                style="margin-left: 16px;" class="icon" alt />
            </el-tooltip>
          </div>
          <div>
            <el-button type="text" @click="statisticsTypeSwitch('p')">
              <span style="font-size: 16px;" class="h-p-switch-item"
                :class="{ 'h-p-switch-active': statisticsType === 'p' }">{{ $t('chi8')
                }}</span>
            </el-button>
            <span> | </span>
            <el-button type="text" @click="statisticsTypeSwitch('m')">
              <span style="font-size: 16px;" class="h-p-switch-item"
                :class="{ 'h-p-switch-active': statisticsType === 'm' }">{{ $t('chi7')
                }}</span>
            </el-button>
            <span> | </span>
            <el-button type="text" @click="statisticsTypeSwitch('mp')">
              <span style="font-size: 16px;" class="h-p-switch-item"
                :class="{ 'h-p-switch-active': statisticsType === 'mp' }">{{ $t('chi50')
                }}</span>
            </el-button>
          </div>
        </div>
        <div class="m-p-list">
          <div v-if="statisticsType === 'mp'" style="position: relative;height: 100%;">
            <div class="h-p-search-c">
              <el-input v-model="mpSearch" type="text" size="mini" :placeholder="$t('chi10')">
                <el-button slot="append" icon="el-icon-search" @click="searchPlayHistory"></el-button>
              </el-input>
            </div>
            <el-table
              :data="priceList.filter(data => !mpSearch || data.name.toLowerCase().includes(mpSearch.toLowerCase()))"
              style="width: 100%" height="100%">
              <el-table-column prop="name" :label="$t('nhi04')" width="200">
                <template slot="header"></template>
                <template slot-scope="scope"> {{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column prop="number" :label="$t('nhi05')">
              </el-table-column>
              <el-table-column prop="price" :label="$t('nhi06')">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" size="mini" @blur="changePrice(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" :label="$t('nhi07')">
              </el-table-column>
            </el-table>
          </div>
          <template v-else>
            <div class="flex-d-c h-p-sort">
              <div style="margin: 10px" class="title-font flex-c-c">
                {{ statisticsType === "m" ? $t('chi7') : $t('chi8') }}
              </div>
              <div class="h-p-sort-l" :style="{ width: '100%', overflowY: 'auto', }" v-if="!pmLoading">
                <div id="chartSort" :style="{ width: '95%', height: 32 * numberLine * 1.6 + 'px' }"></div>
                <div v-if="numberLine === 0" class="flex-c-c" style="height: 100%; color: #909399;font-size: 14px;">
                  {{ $t('terminal.noData') }}</div>
              </div>
            </div>
            <div class="flex-d-b-c h-p-search">
              <div class="h-p-search-c">
                <el-input v-model="search" type="text" size="mini" :placeholder="$t('chi10')">
                  <el-button slot="append" icon="el-icon-search" @click="searchPlayHistory"></el-button>
                </el-input>
              </div>
              <el-table :data="pmList" style="width: 100%" height="100%">
                <el-table-column type="index" width="60">
                </el-table-column>
                <el-table-column>
                  <template slot="header"></template>
                  <template slot-scope="scope"> {{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column :label="$t('nhi01')" prop="start_time" width="160">
                </el-table-column>
                <el-table-column :label="$t('nhi02')" prop="sn" width="140">
                </el-table-column>
              </el-table>
              --{{ $t('chi11') }}--
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="home-content" v-if="true">
      <div class="content-left">
        <h2 class="left-title">
          {{ $t("home.describe1") }}
          <img class="left-img" src="../assets/images/home/cwsystem.png" alt />
        </h2>
        <div class="left-short-border"></div>
        <h3 class="left-subtitle">{{ $t("home.describe2") }}</h3>
        <p class="left-desc">{{ $t("home.describe3") }}</p>
      </div>
      <div class="content-right">
        <img src="../assets/images/home/xwg.png" alt class="right-img" />
      </div>
    </div>
    <div class="home-bg" v-else>
      <img src="../assets/images/home/ljzl-bg.png" alt />
    </div> -->
    <msg-dialog :title="$t('chi12')" :dialogVisible="exportVisible" @closeDialog="closeExport">
      <el-date-picker v-model="exportdate" type="datetimerange" align="right" unlink-panels
        :range-separator="$t('chi13')" :start-placeholder="$t('chi14')" :end-placeholder="$t('chi15')">
      </el-date-picker>
      <div style="padding-top: 8px; font-size: 12px;">{{ $t('chi16') }}</div>
    </msg-dialog>
  </div>
  <div v-else v-loading="true" class="home-container flex-d-b-c" :element-loading-text="$t('cdck15')"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
  </div>
</template>

<script>
import Utils from "@/assets/scripts/Utils";
import { getChildrenIds } from "@/assets/scripts/publicFunction";
import Shortcut from "./children/Shortcut.vue";
import KaresMsg from "./children/KaresMsg.vue";
import { dateFormat, timeFormatting, msFormatting } from "@/assets/scripts/dateFormatting.js";
import XLSX from 'xlsx';
import MsgDialog from '@/components/basics/MsgDialog'
import { mPagination } from "@/components/basics/mixins";
// import { forEach } from 'jszip';
// import Terminal from '../../views/Terminal.vue';

const karesDescribe = "欢迎使用Kares,让世界只有指尖的距离。Kares拥有完美的跨平台解决方案，其基于网络平台，采用分布式区域管理技术，可以有效整合各种多媒体资源，实现远程制作，发布和管理节目。"

// const ShortcutList = [
//   { title: '添加素材', describe: '批量上传，格式丰富，分类查找，海量素材快速定位' },
//   { title: '节目制作', describe: '拖拽式的操作，编排效果所见即所得，快速完成节目制作' },
//   { title: '节目发布', describe: '循环、定时，插播多种播放模式，节目投放井然有序' },
//   { title: '终端控制', describe: '远程控制终端，一键批量操作，一人管千屏得心应手' },
// ];


export default {
  mixins: [mPagination],
  data() {
    return {
      numberLine: 0,
      search: '',
      mpSearch: '',
      statisticsType: 'p',  // m/p
      ShortcutList: [
        { title: this.$t('chi18'), describe: this.$t('chi19') },
        { title: this.$t('chi20'), describe: this.$t('chi21') },
        { title: this.$t('chi22'), describe: this.$t('chi23') },
        { title: this.$t('chi24'), describe: this.$t('chi25') },
      ],
      runState: { 'on': 0, 'off': 0 }, //
      sizeRemark: { size_remark: [], number: [] },
      materialNumber: { image: 0, imageRom: 0, video: 0, videoRom: 0, },
      dmLoading: false,
      pmStatistics: { name: [], number: [] },
      pmList: [],
      priceList: [],
      pmLoading: false,
      karesDescribe,
      systemMemory: "",
      dataMemory: "",
      exportVisible: false,
      exportdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
      downloadLoading: false,
      commonInfoList: []
    };
  },
  created() {
    // setTimeout(() => { this.getGroupList(); }, 100)
    this.systemMemory = `${this.$t('chi26')}${this.$cookies.get('systemMemory')}-`;
    this.dataMemory = `${this.$t('chi27')}${this.$cookies.get('dataMemory')}`;
  },
  mounted() {
    this.getGroupList();
    setTimeout(() => {
      this.initWebSocket();
    }, 1000);
    setTimeout(() => {
      const roleId = this.$cookies.get('role_id');
      if (roleId === '3') {
        this.$router.push({
          path: "/review/materialCheck"
        });
      }
    }, 3000);
  },
  methods: {
    initWebSocket() {
      this.myWebSocket.onmessage = (val) => {
        let upresult = JSON.parse(val.data);
        if (upresult.type === "common_info") {
          this.commonInfoList.push(upresult)
        }
      }
    },
    getAllMac() {
      fetch(`http://pandora.kystarcloud.com/update/getAllMac`, {
        method: 'get'
      }).then(response => response.json()).then(res => {

        let list = res.data.map(m => {
          const { id, mac, model, serial_no, time, version } = m;
          return [id, mac, model, serial_no, version, time]
        })
        const data = [
          ['id', 'mac', 'model', 'serial_no', 'version', 'time'],
          ...list
        ];
        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'MacList.xlsx');
      });
    },
    exportStatistics() {
      this.exportVisible = true;
    },
    async closeExport(confirm) {
      if (confirm) {
        this.downloadLoading = true;
        const start_time = parseInt(this.exportdate[0].getTime() / 1000);
        const end_time = parseInt(this.exportdate[1].getTime() / 1000);

        const getDtae = (time) => {
          let date = new Date(time * 1000);
          let dateStr = dateFormat(date) + "  " + timeFormatting(date);
          return dateStr;
        };


        // await this.$http.post("/admin/play/getPlayHistoryList", { group_ids: this.groupIds, limit: 50000, start_time, end_time }, res => {
        //   exportdata.play = res.map((p, index) => {
        //     const { name, dname, gname, sn, start_time, end_time } = p;
        //     return [index + 1, gname, dname, sn, name, getDtae(start_time), getDtae(end_time), msFormatting((end_time - start_time) * 1000)]
        //   });
        // });
        // await this.$http.post("/admin/play/getHistoryMediaList", { group_ids: this.groupIds, limit: 50000, start_time, end_time }, res => {
        //   exportdata.media = res.map((m, index) => {
        //     const { name, dname, gname, sn, start_time, duration } = m;
        //     return [index + 1, gname, dname, sn, name, getDtae(start_time), getDtae(start_time + duration), msFormatting(duration * 1000)]
        //   });
        // });
        let exportdata = { media: [], play: [] };
        const limit = 50000;

        await Promise.all([
          this.$http.post("/admin/play/getPlayHistoryList",
            { group_ids: this.groupIds, limit, start_time, end_time },
            res => {
              exportdata.play = res.map((p, index) => {
                const { name, dname, gname, sn, start_time, end_time } = p;
                return [index + 1, gname, dname, sn, name, getDtae(start_time), getDtae(end_time), msFormatting((end_time - start_time) * 1000)]
              });
            }),
          this.$http.post("/admin/play/getHistoryMediaList",
            { group_ids: this.groupIds, limit, start_time, end_time },
            res => {
              exportdata.media = res.map((m, index) => {
                const { name, dname, gname, sn, start_time, duration } = m;
                return [index + 1, gname, dname, sn, name, getDtae(start_time), getDtae(start_time + duration), msFormatting(duration * 1000)]
              });
            })]);

        const { play, media } = exportdata;

        if (play.length === 0 && media.length === 0) {
          this.$msg({ message: this.$t('chi28'), type: "warning", showClose: true });
          this.downloadLoading = false;
          return;
        } else {
          this.$msg({ message: "this.$t('chi29')", type: "success", showClose: true });
        }
        const exP = [['序号', '设备分类', '设备名称', '设备SN', '节目名称', '开始时间', '结束时间', '播放时间'], ...play];
        const exM = [['序号', '设备分类', '设备名称', '设备SN', '素材名称', '开始时间', '结束时间', '播放时间'], ...media];

        const exPE = XLSX.utils.aoa_to_sheet(exP);
        const exME = XLSX.utils.aoa_to_sheet(exM);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, exPE, '节目播放记录');
        XLSX.utils.book_append_sheet(wb, exME, '素材播放记录');
        XLSX.writeFile(wb, `播放记录列表_${dateFormat(new Date())}.xlsx`);
        this.downloadLoading = false;
      }
      this.exportVisible = false;
    },
    async getGroupList() {
      await this.$http.post("/admin/access/groupList", {}, data => {
        let groupList = Utils.MSDataTransfer.treeToArray(data, null, null, self.defaultExpandAll);
        let ids = getChildrenIds(groupList, this.$cookies.get("group_id")).join(",");
        // this.$cookies.set("group_ids", ids);
        sessionStorage.setItem('group_ids', ids);
      });
      await this.getChartData();
    },

    async getChartData() {
      this.dmLoading = true;
      this.pmLoading = true;

      //left
      await this.getDeviceNumber();
      await this.getMaterialNumber();

      this.dmLoading = false;
      // 初始化图表
      setTimeout(() => {
        this.chartOnline();
        this.chartResolution();
        this.chartMaterialNum();
        this.chartMaterialType();
        this.$forceUpdate();
      });

      //right
      await this.getPlayHistoryList();
      await this.getPlayHistoryStatistics();

      this.pmLoading = false;
      // 初始化图表
      setTimeout(() => {
        this.chartSort();
        this.$forceUpdate();
      });
    },
    chartInit() {
      this.chartOnline();
      this.chartResolution();
      this.chartMaterialNum();
      this.chartMaterialType();
      this.chartSort();
    },

    async getDeviceNumber() {
      await this.$http.post("/admin/device/getDeviceNumber", { group_ids: sessionStorage.getItem('group_ids'), }, data => {
        const { runState, sizeRemark } = data;
        runState.forEach((item) => {
          const { run_state, number } = item;
          if (run_state == 0) {
            this.runState['off'] = number;
          } else {
            this.runState['on'] += number;
          }
        });

        sizeRemark.sort((a, b) => b.number - a.number);
        const showNum = 8;
        let hide = 0;
        sizeRemark.forEach((item, index) => {
          const { size_remark, number } = item;
          if (index < showNum) {
            this.sizeRemark.size_remark.push(size_remark);
            this.sizeRemark.number.push(number);
          } else {
            hide += number;
          }
        });
        if (hide > 0) {
          this.sizeRemark.size_remark.push(this.$t('nhi03'));
          this.sizeRemark.number.push(hide);
        }
      });
    },
    async getMaterialNumber() {
      await this.$http.post("/admin/material/getMaterialNumber", { group_ids: sessionStorage.getItem('group_ids'), }, data => {
        this.materialNumber = data;
      });
    },
    async getPlayHistoryList(keyword = '') {
      await this.$http.post("/admin/play/getPlayHistoryList", { group_ids: sessionStorage.getItem('group_ids'), key_word: keyword }, res => {
        this.pmList = res.map((item) => {
          let d = new Date(item.start_time * 1000);
          item.start_time = dateFormat(d) + "  " + timeFormatting(d);
          return item;
        });
      });
    },
    async getPlayHistoryStatistics() {
      await this.$http.post("/admin/play/getPlayHistoryStatistics", { group_ids: sessionStorage.getItem('group_ids'), }, data => {
        this.numberLine = data.length;
        data.forEach((item) => {
          const { name, number } = item;
          this.pmStatistics.name.push(name);
          this.pmStatistics.number.push(number);
        });
      });
    },
    async getHistoryMediaList(keyword = '') {
      await this.$http.post("/admin/play/getHistoryMediaList", { group_ids: sessionStorage.getItem('group_ids'), key_word: keyword }, res => {
        this.pmList = res.map((item) => {
          let d = new Date(item.start_time * 1000);
          item.start_time = dateFormat(d) + "  " + timeFormatting(d);
          return item;
        });
      });
    },
    async getHistoryMediaStatistics(limit = 100) {
      let list = []
      await this.$http.post("/admin/play/getHistoryMediaStatistics", { group_ids: sessionStorage.getItem('group_ids'), limit }, data => {
        this.numberLine = data.length;
        list = data;
        data.forEach((item) => {
          const { name, number } = item;
          this.pmStatistics.name.push(name);
          this.pmStatistics.number.push(number);
        });
      });
      return list;
      // this.$forceUpdate();
    },
    async statisticsTypeSwitch(type) {
      this.statisticsType = type;
      this.pmList = [];
      this.pmStatistics = { name: [], number: [] };
      this.pmLoading = true;

      switch (type) {
        case 'p':
          await this.getPlayHistoryList();
          await this.getPlayHistoryStatistics();
          break;
        case 'm':
          await this.getHistoryMediaList();
          await this.getHistoryMediaStatistics();
          break;
        case 'mp':
          {
            let mList = await this.getHistoryMediaStatistics(-1);
            this.priceList = await this.getMediaPrice(mList);
            this.pmLoading = false;
          }
          return;
        default:
          break;
      }

      this.pmLoading = false;
      setTimeout(() => {
        this.chartSort();
        this.$forceUpdate();
      });
    },
    changePrice(m) {
      const isNumberOrDecimal = (str) => {
        const regex = /^(\d+(\.\d{1,2})?)$/;
        return regex.test(str);
      }
      const { name, number, price, totalPrice } = m;
      if (isNumberOrDecimal(price)) {
        m.price = parseFloat(price).toFixed(2);
        m.totalPrice = number * price;
        this.$http.post("/admin/material/setMediaPrice", { name, price }, data => {
          console.log(data);
        });
      } else {
        m.price = (totalPrice / number).toFixed(2);
        this.$msg({ message: "无效值", type: "warning", showClose: true });
      }
    },

    async getMediaPrice(mList) {

      if (this.pmStatistics.name.length === 0) {
        return [];
      }
      let list = [];
      await this.$http.post("/admin/material/getMediaPrice", { names: this.pmStatistics.name.join(',') }, data => {
        list = mList.map(m => {
          let p = data.find(p => p.name === m.name);
          return p ? { ...m, ...p, totalPrice: (m.number * p.price).toFixed(2) } : { ...m, price: 0, totalPrice: 0 };
        });
      });
      return list;
    },

    async searchPlayHistory() {
      if (this.statisticsType === 'p') {
        await this.getPlayHistoryList(this.search);
      }
      if (this.statisticsType === 'm') {
        await this.getHistoryMediaList(this.search);
      }
    },
    changeMpSearch(val) {
      console.log(val);
      this.mpSearch += val;
    },

    handleEdit(index, row) {
      console.log(index, row);
    },

    handleDelete(index, row) {
      console.log(index, row);
    },
    chartOnline() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('chartOnline'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.$t('chi41'),
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'vertical',
          left: '0px',
          bottom: '40px'
        },
        series: [
          {
            name: this.$t('csca17'),
            type: 'pie',
            radius: '70%',
            label: {
              position: 'inside',
              formatter: '{b} : {c}'
            },
            data: [
              { value: this.runState['on'], name: this.$t('cdcp35'), itemStyle: { color: '#91cc75' } },
              { value: this.runState['off'], name: this.$t('cdcp36'), itemStyle: { color: '#ee6666' } },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    chartResolution() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('chartResolution'))
      // 绘制图表
      myChart.setOption({
        title: { text: this.$t('chi42'), left: 'center' },
        tooltip: {},
        grid: {
          left: '4%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          data: this.sizeRemark.size_remark,
          axisLabel: { interval: 0, rotate: 45 }
        },
        yAxis: {},
        series: [{
          name: this.$t('chi43'),
          type: 'bar',
          label: {
            show: true,
            position: 'top'
          },
          data: this.sizeRemark.number,
          itemStyle: {
            color: getComputedStyle(document.documentElement).getPropertyValue('--theme-color-customized-1').trim(),
          },
        }]
      });
    },
    chartMaterialNum() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('chartMaterialNum'));
      const { image, video } = this.materialNumber;
      // 绘制图表
      myChart.setOption({
        title: { text: this.$t('chi44'), left: 'center' },
        tooltip: {},
        xAxis: {
          data: [this.$t('chi45'), this.$t('chi46')],
          // axisLabel: { interval: 0, rotate: 30 }
        },
        grid: {
          left: '4%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        yAxis: {},
        series: [{
          name: this.$t('chi47'),
          type: 'bar',
          label: {
            show: true,
            position: 'top'
          },
          data: [image, video],
          itemStyle: {
            color: getComputedStyle(document.documentElement).getPropertyValue('--theme-color-customized-1').trim(),
          },
        }]
      });
    },
    chartMaterialType() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('chartMaterialType'));
      const { imageRom, videoRom } = this.materialNumber;
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.$t('chi48'),
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: '0px',
          bottom: '40px'
        },
        series: [
          {
            name: this.$t('chi49'),
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              position: 'inside',
            },
            labelLine: {
              show: false
            },
            tooltip: {
              show: true,
              trigger: 'item',
              alwaysShowContent: true,
              formatter: (params) => {
                // console.log(params);
                const { name, value } = params.data;
                return `${this.$t('chi49')} <br/>${name} : ${this.storage(value)}(${params.percent}%)`;
              }
            },
            data: [
              {
                value: videoRom, name: this.$t('chi46'),
                itemStyle: {
                  color: getComputedStyle(document.documentElement).getPropertyValue('--theme-color-customized-1').trim()
                }
              },
              {
                value: imageRom, name: this.$t('chi45'),
                itemStyle: {
                  color: getComputedStyle(document.documentElement).getPropertyValue('--theme-color-green-1').trim()
                }
              },
            ],
          }
        ]
      });
    },
    chartSort() {
      const { name, number } = this.pmStatistics;
      let myChart = this.$echarts.init(document.getElementById('chartSort'));
      // 绘制图表
      myChart.setOption({
        // title: {
        //   text: '节目播放',
        //   // subtext: 'Fake Data',
        //   left: 'center'
        // },
        grid: {
          top: 0,
          bottom: 30,
        },
        xAxis: {
          max: 'dataMax',
        },
        yAxis: {
          type: 'category',
          data: name,
          inverse: true,
          axisLabel: {
            inside: true,
            color: '#ccc',
            overflow: true,
            ellipsis: '...',
          },
          // axisTick: {
          //   show: false
          // },
          // axisLine: {
          //   show: false
          // },
          z: 10,
          animationDuration: 300,
          animationDurationUpdate: 300,
          // max: 2 // only the largest 3 bars will be displayed
        },
        series: [
          {
            realtimeSort: true,
            name: 'X',
            type: 'bar',
            barWidth: 32,
            data: number,
            label: {
              show: true,
              position: 'left',
              valueAnimation: true
            },
            labelLayout: {
              width: 100,
              height: 100
            },
            itemStyle: {
              color: getComputedStyle(document.documentElement).getPropertyValue('--theme-color-customized-1').trim()
            }
          }
        ],
        legend: {
          show: false
        },
        animationDuration: 0,
        animationDurationUpdate: 3000,
        animationEasing: 'linear',
        animationEasingUpdate: 'linear'
      });
    },
    storage(refSize) {
      let refSizeMB = refSize / 1024 / 1024;
      if (refSizeMB < 1) {
        refSize = (refSizeMB * 1024).toFixed(1) + "KB";
      } else if (refSizeMB >= 1 && refSizeMB < 1024) {
        refSize = refSizeMB.toFixed(1) + "MB";
      } else if (refSizeMB >= 1024) {
        refSize = (refSizeMB / 1024).toFixed(1) + "GB";
      }
      return refSize
    },

  },
  components: {
    Shortcut,
    KaresMsg,
    MsgDialog
    // Terminal
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    }
  },
};
</script>

<style lang='scss' scoped>
.home-container {
  margin: 12px;
  width: calc(100% - 24px);
  height: calc(100% - 24px);
  border-radius: 8px;
  // background: #fff;
  overflow: hidden;

  .title-font {
    font-size: 18px;
    font-weight: bolder;
    font-family: "sans-serif";
    color: #333;
  }

  .navigation {
    width: 100%;
    height: 120px;
    background: #fff;
    border-radius: 8px;

    .arrow-right {
      height: 50px;
    }
  }

  .h-chart {
    width: 100%;
    height: calc(100% - 120px - 8px);

    .h-msg,
    .h-device,
    .h-program {
      height: 100%;
      border-radius: 8px;
      overflow-y: auto;
      background: #fff;
    }

    .h-msg {
      width: calc(25% - 8px);

      // background: blue;
      .title-font {
        height: 40px;
        padding: 0px 16px;
        border-bottom: 1px solid #d7ecf3;
      }

      .msg-body {
        height: calc(100% - 42px);
        overflow-x: hidden;
        overflow-y: auto;
      }
    }

    .h-device {
      width: calc(35% - 8px);
      height: calc(100% - 8px);
      padding-top: 8px;

      // background: red;
      #chartOnline,
      #chartResolution,
      #chartMaterialNum,
      #chartMaterialType {
        width: 48%;
        height: 300px;
      }
    }

    .h-program {
      width: 40%;

      // background: green;
      .h-p-switch {
        height: 40px;
        padding: 0px 16px;
        border-bottom: 1px solid #d7ecf3;
        // background: green;
      }

      .h-p-switch-active {
        font-weight: bolder;
        font-family: "sans-serif";
        color: var(--theme-color-customized-1) !important;
      }

      .h-p-switch-item {
        color: #333
      }

      .m-p-list {
        height: calc(100% - 40px - 2px);
        border-radius: 8px;
        overflow-y: auto;
        padding-right: 16px;

        .h-p-sort {
          height: calc(100% - 30% - 40px - 16px);
          margin-bottom: 16px;

          .h-p-sort-l {
            height: calc(100% - 40px);
          }
        }

        .h-p-search {
          height: 30%;
          height: 400px;
          position: relative;

          .h-p-search-c {
            position: absolute;
            z-index: 1;
            left: 0px;
            top: 12px;
            margin: 0px 8px;
            width: 200px;
          }
        }

        .h-p-search-c {
          position: absolute;
          z-index: 1;
          left: 0px;
          top: 12px;
          margin: 0px 8px;
          width: 200px;
        }
      }
    }
  }

  // position: relative;
  // margin: 0 0 0 -15px;
  // .home-bg {
  //   height: 70%;
  //   img {
  //     height: 100%;
  //   }
  // }
  // .home-content {
  //   width: 734px;
  //   height: 250px;
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   bottom: 0;
  //   margin: auto;
  //   display: flex;
  //   .content-left {
  //     width: 400px;
  //     padding-right: 50px;
  //     .left-title {
  //       font-size: 36px;
  //       color: #4375a1;
  //       line-height: 56px;
  //       .left-img {
  //         vertical-align: top;
  //         height: 56px;
  //       }
  //     }
  //     .left-subtitle {
  //       font-size: 24px;
  //       color: #769aba;
  //     }
  //     .left-short-border {
  //       width: 54px;
  //       height: 3px;
  //       background: #769aba;
  //       margin: 26px 0 20px;
  //     }
  //     .left-desc {
  //       padding-top: 32px;
  //       line-height: 22px;
  //       font-size: 14px;
  //       color: #769aba;
  //     }
  //   }
  //   .content-right {
  //     width: 374px;
  //     height: 264px;
  //     .right-img {
  //       width: 100%;
  //       height: 100%;
  //     }
  //   }
  // }
}
</style>
